<template>
  <div>
    <top-bar />

    <main-content />

    <back-top />

    <coupon-overlay />
    <newyear-overlay ref="newyearOverlay" />
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import TopBar from './components/TopBar'
import BackTop from './components/BackTop'
import MainContent from './main-content'
import CouponOverlay from './coupon-overlay'
import NewyearOverlay from './newyear-overlay'
import { MAMMON_ARRAY } from '@/config/mammonArray'
import { getCouponStatus, takeCouponBatch } from '@/api/coupon'

export default {
  name: 'PuhuiHome',
  components: {
    TopBar,
    BackTop,
    MainContent,
    CouponOverlay,
    NewyearOverlay
  },
  data() {
    return {
      couponsStatus: [],
      isUnionMember: false,
      unTakedCouponsIds: []
    }
  },
  activated() {
    if (this.$refs.newyearOverlay.show) {
      this.$refs.newyearOverlay.hideOverlay()

      setTimeout(() => {
        this.loadNewyearCouponOverlay()
      }, 200)
    }
  },
  created() {
    this.loadNewyearCouponOverlay()
  },
  methods: {
    loadNewyearCouponOverlay() {
      this.isUnionMember = Cookies.get('memberStatus') == 1

      getCouponStatus({ denominationIds: MAMMON_ARRAY.join(',') }).then(res => {
        const result = res.data
        if (result.code === 200) {
          this.couponsStatus = result.data

          // 普惠会员 => 领取take=false的券
          // 非普惠会员 => 领取onlyForUnionMember=false&&take=false的券
          this.unTakedCouponsIds = Array.from(
            this.isUnionMember
              ? this.couponsStatus.filter(item => !item.take)
              : this.couponsStatus.filter(item => !item.take && !item.onlyForUnionMember),
            e => e.denominationId
          )

          // 有未领取的优惠券则弹出弹窗
          if (this.unTakedCouponsIds.length > 0) {
            this.$refs.newyearOverlay.showOverlay()
          }
        } else {
          this.$toast.fail(result.msg)
        }
      })
    },
    takeNewyearCoupons() {
      if (this.unTakedCouponsIds.length > 0) {
        takeCouponBatch(this.unTakedCouponsIds).then(res => {
          const result = res.data
          if (result.code === 200) {
            this.unTakedCouponsIds = []
            this.$toast.success('领取成功')
            this.$router.push('/mammon-detail')
          } else {
            this.$toast.fail(result.msg)
          }
        })
      } else {
        this.$router.push('/mammon-detail')
      }
    }
  }
}
</script>
